// extracted by mini-css-extract-plugin
export default {"icon":"Button_icon__MLGkH"};